import { useDebugValue } from 'react';
import { ISlot } from '../../organisms/bo_calendar_slot/types';
import { IResource } from '../types';
import { useCalendarStoreSelector } from './useCalendarStoreSelector';

export const useUpdateSlot = () => {
	useDebugValue('useUpdateSlot');

	const updateResourceSlot = useCalendarStoreSelector(state => state.updateResourceSlot);

	return {
		updateResourceSlot,
	};
};
